import { render } from "./Menu.vue?vue&type=template&id=9cb92de8&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=9cb92de8&lang=scss&scoped=true"

import exportComponent from "E:\\项目\\潞安6s移动端\\H5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cb92de8"]])

export default __exports__